
define(function (require) {
    "use strict";

    var LE = require("app");

    var KEYS = {
        NAME: "name",
        VALUE: "value"
    };

    var WidgetParametersModel = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetParametersModel = Backbone.Model.extend({
            validation: {
                "name": [
                    {
                        required:true,
                        minLength:1,
                        msg: "LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.errors.name.empty"
                    },
                    {
                        pattern:"url",
                        msg: "LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.errors.name.invalid"
                    },
                    {
                        fn:function () {
                            if (this.errors.withinListDuplicated) {
                                return "LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.errors.name.taken";
                            }
                        }

                    }
                ],
                "value": [
                    {
                        required:true,
                        minLength:1,
                        msg: "LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.errors.value.empty"
                    }
                ]
            },
            name: "WidgetParametersModel",

            initialize: function(){
                this.errors = {withinListDuplicated: false};
            },

            clearErrors: function(){
                this.errors.withinListDuplicated = false;
            },

            getModelName: function(){
                return this.get(KEYS.NAME);
            },
            getModelValue: function(){
                return this.get(KEYS.VALUE);
            }
        });
    });

    WidgetParametersModel.KEYS = KEYS;
    return WidgetParametersModel;
});
